import React, { PureComponent, ReactNode } from 'react'
import clsx from 'clsx'

import './IconButton.scss'

interface IconButtonProps extends React.HTMLAttributes<any> {
  children: ReactNode,
  active: boolean,
  disabled: boolean,
  type: 'submit' | 'button',
  size: '' | 'big',
  caption: string,
  captionHorizontal: boolean,
  component: string,
  className: string
}

class IconButton extends PureComponent<IconButtonProps> {
  static defaultProps: Partial<IconButtonProps> = {
    active: false,
    disabled: false,
    type: 'button',
    caption: '',
    captionHorizontal: false,
    component: 'button',
    size: '',
    className: ''
  }

  render() {
    const {
      children,
      caption,
      captionHorizontal: isCaptionHorizontal,
      component: Component,
      className,
      type,
      active: isActive,
      disabled: isDisabled,
      size,
      ...props
    } = this.props
    let targetProps: any

    if (size && caption) {
      throw Error('Size attr is only applicable without a caption')
    }

    // use 'disabled' and 'type' attrs only on button element
    if (Component === 'button') {
      targetProps = {
        ...props,
        type,
        disabled: isDisabled
      }
    } else {
      targetProps = props
    }

    return (
      <Component
        {...targetProps}
        className={clsx(
          'icon-button',
          size && `icon-button_${size}`,
          {'icon-button_horizontal': isCaptionHorizontal},
          {'icon-button_disabled': isDisabled},
          {'icon-button_active': isActive},
          className
        )}
      >
        <span className="icon-button__inner">
          {children}
          {caption && <span className="icon-button__caption">{caption}</span>}
        </span>
      </Component>
    )
  }
}

export default IconButton
